import React from 'react';
import { FiShare2 } from 'react-icons/fi';
import { formatCount } from '../../format';

export const PROFILE_AVATAR = '/android-chrome-192x192.png';

const Stat = ({ value, label }) => (
    <li>
        <strong>{value === null ? '–' : formatCount(value)}</strong> {label}
    </li>
);

const ProfileHeader = ({ loading, viewsReady, postCount, views, likes, user, onLogin, onSaved, onMessage, onShare }) => (
    <section className="ig-header">
        <div className="ig-avatar">
            <img src={PROFILE_AVATAR} alt="" width="150" height="150" fetchpriority="high" />
        </div>
        <div className="ig-info">
            <h1 className="ig-username">pinkwire</h1>
            <ul className="ig-stats">
                <Stat value={loading ? null : postCount} label="posts" />
                <Stat value={loading || !viewsReady ? null : views} label="views" />
                <Stat value={loading ? null : likes} label="likes" />
            </ul>
            <p className="ig-bio">
                <strong>Pinkwire</strong>
                <br />
                Tap any post to watch.
            </p>
        </div>
        <div className="ig-cta">
            {user ? (
                <button type="button" className="ig-btn" onClick={onSaved}>Saved</button>
            ) : (
                <button type="button" className="ig-btn ig-btn--primary" onClick={onLogin}>Log in</button>
            )}
            <button type="button" className="ig-btn" onClick={onMessage}>Message</button>
            <button type="button" className="ig-btn ig-btn--icon" onClick={onShare} aria-label="Share profile">
                <FiShare2 aria-hidden="true" />
            </button>
        </div>
    </section>
);

export default ProfileHeader;
